<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99996 18.3333C14.6023 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6023 1.66667 9.99996 1.66667C5.39759 1.66667 1.66663 5.39763 1.66663 10C1.66663 14.6024 5.39759 18.3333 9.99996 18.3333Z"
      :stroke="iconColor"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M14.9878 4.16667C14.5697 4.44158 14.2769 4.99093 14.2769 5.51065C14.2769 6.19769 14.6691 6.79902 15.1048 7.48651C15.4536 8.04498 15.8019 8.77487 15.8019 9.80611C15.8019 10.5365 15.5841 11.4382 15.1483 12.5552L14.2769 15.3899L11.1828 6.28385C11.7059 6.241 12.1851 6.19815 12.1851 6.19815C12.6209 6.15529 12.5774 5.51111 12.1417 5.51111C12.1417 5.51111 12.1417 5.51111 12.0982 5.51111C12.0982 5.51111 10.7036 5.64013 9.78861 5.64013C8.96062 5.64013 7.52251 5.51111 7.52251 5.51111C7.52251 5.51111 7.52251 5.51111 7.47903 5.51111C7.0433 5.51111 6.99982 6.19815 7.43555 6.19815C7.43555 6.19815 7.87128 6.241 8.35096 6.28385L9.70211 9.89182L7.82827 15.4328L4.69024 6.241C5.2134 6.19815 5.69261 6.15529 5.69261 6.15529C6.12835 6.11244 6.08487 5.46826 5.64913 5.46826C5.64913 5.46826 5.64913 5.46826 5.60565 5.46826C5.60565 5.46826 4.55979 5.57174 3.71423 5.60183C3.14343 6.33218 2.77476 7.03699 2.5 7.94332L5.77587 16.7562C6.37721 17.147 7.03081 17.4519 7.73252 17.6667L10.0509 10.9659L12.5261 17.6065C13.2495 17.3744 13.9295 17.0494 14.5396 16.6199L16.8492 10.0213C17.1933 9.16238 17.4218 8.28615 17.5 7.61598C17.1572 6.47442 16.0711 4.90842 14.9878 4.16667Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style>
</style>